'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.CallToActionImageComponent = CallToActionImageComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function CallToActionImageComponent(_ref) {
  var backgroundImage = _ref.backgroundImage,
      body = _ref.body,
      buttonContents = _ref.buttonContents,
      className = _ref.className,
      postTitle = _ref.postTitle,
      preTitle = _ref.preTitle,
      route = _ref.route,
      title = _ref.title;

  var bgStyle = backgroundImage ? { backgroundImage: 'url(\'' + backgroundImage + '\')' } : undefined;

  return _react2.default.createElement(
    'div',
    { key: title, className: className },
    _react2.default.createElement(
      'div',
      { className: 'CTAButton_wrapper' },
      _react2.default.createElement(
        _bdcoreNamedRoutes.Link,
        { name: route },
        _react2.default.createElement(
          'div',
          { className: 'CTAButton_inner', style: bgStyle },
          buttonContents && _react2.default.createElement(
            'div',
            { className: 'CTAButton_buttonContainer' },
            buttonContents
          ),
          _react2.default.createElement(
            'div',
            { className: 'CTAButton_box' },
            preTitle && _react2.default.createElement(
              'div',
              { className: 'CTAButton_preTitle' },
              preTitle
            ),
            title && _react2.default.createElement(
              'div',
              { className: 'CTAButton_title' },
              title
            ),
            postTitle && _react2.default.createElement(
              'div',
              { className: 'CTAButton_postTitle' },
              postTitle
            ),
            body && _react2.default.createElement(
              'div',
              { className: 'CTAButton_body' },
              body
            )
          )
        )
      )
    )
  );
}

CallToActionImageComponent.propTypes = {
  backgroundImage: _propTypes2.default.string,
  body: _propTypes2.default.string,
  buttonContents: _propTypes2.default.node,
  className: _propTypes2.default.string,
  postTitle: _propTypes2.default.string,
  preTitle: _propTypes2.default.string,
  route: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired
};

CallToActionImageComponent.defaultProps = {
  backgroundImage: undefined,
  body: undefined,
  buttonContents: undefined,
  className: undefined,
  postTitle: undefined,
  preTitle: undefined
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(CallToActionImageComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-calltoactionimage/build/CallToActionImage.js
// module id = 986
// module chunks = 0